<ng-container *ngIf="isAuthenticated$ | async">
    <ng-content></ng-content>
</ng-container>
